import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.models';
import {
  NotificationItem,
  RegisterNotificationDeviceResponse,
  TestNotificationRequest,
  TestNotificationResponse,
} from '../models/product.models';
import { PagedResponse } from '../models/user.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly api = inject(ApiService);

  list(): Observable<NotificationItem[]> {
    return this.api
      .get<
        | ApiResponse<NotificationItem[] | PagedResponse<NotificationItem>>
        | NotificationItem[]
        | PagedResponse<NotificationItem>
      >(API_ENDPOINTS.notifications.me, undefined, 'marketplace')
      .pipe(
        map((response) => unwrapApiResponse(response)),
        map((response) =>
          Array.isArray(response)
            ? response
            : (response.items ?? response.data ?? response.results ?? []),
        ),
      );
  }

  markRead(notificationId: string): Observable<void> {
    return this.api
      .put<ApiResponse<void> | void, { read: boolean }>(
        `${API_ENDPOINTS.notifications.base}/${notificationId}/read`,
        { read: true },
        'marketplace',
      )
      .pipe(map((response) => unwrapApiResponse(response)));
  }

  sendTest(payload: TestNotificationRequest): Observable<TestNotificationResponse> {
    return this.api
      .post<
        ApiResponse<TestNotificationResponse> | TestNotificationResponse,
        TestNotificationRequest
      >(API_ENDPOINTS.notifications.test, payload, 'marketplace', 15000)
      .pipe(map((response) => unwrapApiResponse(response)));
  }

  registerDevice(registrationToken: string): Observable<RegisterNotificationDeviceResponse> {
    return this.api
      .post<
        ApiResponse<RegisterNotificationDeviceResponse> | RegisterNotificationDeviceResponse,
        {
          token: string;
          provider: string;
          deviceType: string;
        }
      >(
        API_ENDPOINTS.notifications.deviceTokens,
        { token: registrationToken, provider: 'Firebase', deviceType: 'Web' },
        'marketplace',
        15000,
      )
      .pipe(map((response) => unwrapApiResponse(response)));
  }
}
